<h1>Welcome to Hazardous Waste Tracking System</h1>
